import IntensityIcon from "@components/icons/IntensityIcon";
import styledParser from "@libs/parser/styled-parser";

interface IActivityPageTopSection {
  data: any;
}

const ActivityPageTopSection = ({
  data,
}: IActivityPageTopSection): JSX.Element => {
  return (
    <>
      <div className="mx-5 mb-12 text-p text-darkgray desktop:mx-0">
        {styledParser(data.Overview)}
      </div>
      <div className="dekstop:mx-0 mx-5 mb-3 text-h5 font-medium desktop:mx-0">
        Intensity
      </div>
      <div className="mx-5 flex desktop:mx-0 desktop:mb-[2.5rem]">
        <div className="mr-2 flex items-center">
          <IntensityIcon />
        </div>
        <div>{data.Intensity}</div>
      </div>
    </>
  );
};

export default ActivityPageTopSection;
